module.exports = __webpack_public_path__ + "static/media/blog-detail1.e2603a5d.svg";